module.exports = __webpack_public_path__ + "img/pause2.d79fe8ab.png";